import { styled } from "@mui/system";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/material";

export const BRAND_PRIMARY_COLOR = "#AF3241";

/** Standard variant TextField underline (idle, hover, focus). */
export const brandStandardUnderlineFieldSx = {
  "& .MuiInput-underline::before": {
    borderColor: BRAND_PRIMARY_COLOR,
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled)::before": {
    borderColor: BRAND_PRIMARY_COLOR,
  },
  "& .MuiInput-underline::after": {
    borderColor: BRAND_PRIMARY_COLOR,
  },
};

/** Standard underline on the Input/Select root (element has MuiInput-underline). */
export const brandStandardUnderlineInputRootSx = {
  "&.MuiInput-underline::before": {
    borderColor: BRAND_PRIMARY_COLOR,
  },
  "&.MuiInput-underline:hover:not(.Mui-disabled)::before": {
    borderColor: BRAND_PRIMARY_COLOR,
  },
  "&.MuiInput-underline::after": {
    borderColor: BRAND_PRIMARY_COLOR,
  },
};

/** Input root underline for pickers / InputProps.sx (standard variant). */
export const brandStandardUnderlineInputPropsSx = {
  "&:before": {
    borderBottomColor: BRAND_PRIMARY_COLOR,
  },
  "&:hover:not(.Mui-disabled):before": {
    borderBottomColor: BRAND_PRIMARY_COLOR,
  },
  "&:after": {
    borderBottomColor: BRAND_PRIMARY_COLOR,
  },
};

export const CustomTextInputLeftAligned = styled(TextField)({
  color: BRAND_PRIMARY_COLOR,
  fontSize: "14px",
  "& .MuiInput-input": {
    color: BRAND_PRIMARY_COLOR,
    textAlign: "left",
    fontSize: "14px",
    padding: "0px",
  },
  "& .MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: BRAND_PRIMARY_COLOR,
  },
  ...brandStandardUnderlineFieldSx,
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
  },
});

// center alinged text intput
export const CustomTextInputCenterAligned = styled(TextField)({
  color: BRAND_PRIMARY_COLOR,
  fontSize: "14px",
  "& .MuiInput-input": {
    color: BRAND_PRIMARY_COLOR,
    textAlign: "center",
    fontSize: "14px",
    padding: "0px",
  },
  "& .MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: BRAND_PRIMARY_COLOR,
  },
  ...brandStandardUnderlineFieldSx,
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
  },
});

// Create a styled component for the custom input
export const CustomTextInput = styled(TextField)({
  color: BRAND_PRIMARY_COLOR,
  fontSize: "13px",
  "& .MuiInput-input": {
    color: BRAND_PRIMARY_COLOR,
  },
  "& .MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
    fontSize: "14px",
  },
  "& .MuiInputLabel-formControl": {
    color: BRAND_PRIMARY_COLOR,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: BRAND_PRIMARY_COLOR,
  },
  ...brandStandardUnderlineFieldSx,
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
  },
});

// styled text area autosize input
export const CustomTextAreaInput = styled(TextareaAutosize)({
  color: BRAND_PRIMARY_COLOR,
  fontSize: "13px",
  "& .MuiInput-input": {
    color: BRAND_PRIMARY_COLOR,
  },
  "& .MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: BRAND_PRIMARY_COLOR,
  },
  ...brandStandardUnderlineFieldSx,
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
  },
});

export const CustomWhiteColoredInput = styled(TextField)({
  color: "#fff",
  "& .MuiInput-input": {
    color: "#fff",
  },
  "& .MuiInputLabel-root": {
    color: "#fff",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#fff",
  },
  "& .MuiInput-underline::before": {
    borderColor: "#fff",
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled)::before": {
    borderColor: "#fff",
  },
  "& .MuiInput-underline::after": {
    borderColor: "#fff",
  },
});

export const StyledDateTextField = styled(TextField)({
  "& .MuiInput-input": {
    color: BRAND_PRIMARY_COLOR,
    fontSize: "15.305px",
    cursor: "text",
    caretColor: BRAND_PRIMARY_COLOR,
    "&::selection": {
      backgroundColor: "rgba(175, 50, 65, 0.3)",
    },
  },
  "& .MuiInputLabel-root": {
    color: BRAND_PRIMARY_COLOR,
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: BRAND_PRIMARY_COLOR,
  },
  ...brandStandardUnderlineFieldSx,
  "& .MuiInputAdornment-root": {
    display: "none",
  },
});
